import { BackToolbarComponent } from "@/components/toolbar/back-toolbar";
import { useSafeAreaStyles } from "@/hooks/utils/use-safe-area-styles";
import { cn } from "@/utils/cn";
import { IonContent, IonPage } from "@ionic/react";
import { forwardRef, ReactNode } from "react";

interface SwapPlanPageContainerProps {
  children: ReactNode;
  className?: string;
  onBack?: () => void;
  actionButton?: React.ReactNode;
}

export const SwapPlanPageContainer = forwardRef<HTMLElement, SwapPlanPageContainerProps>(
  function SwapPlanPageContainer({ children, className, onBack, actionButton }, ref) {
    const safeAreaStyles = useSafeAreaStyles();

    return (
      <IonPage ref={ref} color="white" style={{ ...safeAreaStyles }}>
        <BackToolbarComponent
          onBack={onBack}
          title="I’ve found you some options..."
          titleFontSize="title3"
          bgColor="white"
          actionButton={actionButton}
        />
        <IonContent color="white" scrollY={false} forceOverscroll={false}>
          <div
            className={cn(
              "mx-auto flex h-full w-full max-w-[450px] flex-col items-center justify-start gap-10 overflow-hidden pt-3 pb-10",
              className,
            )}
          >
            {children}
          </div>
        </IonContent>
      </IonPage>
    );
  },
);
